const appEnv = import.meta.env.VITE_APP_ENV || "production";

/**
 * @param {string} env production | dev | test
 * @constructor
 * @return boolean
 */
export function IsEnv(env) {
  return appEnv === env;
}

export function IsProduction() {
  return IsEnv("production");
}

export function IsDev() {
  return IsEnv("dev");
}

export function IsTest() {
  return IsEnv("test");
}

export function IsLocal() {
  return IsEnv("local");
}
